"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgFilePdf64 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 .5h64v64H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M47 24.5H36v-11m11 11.138V51.5H16v-38h20.02L47 24.638h0ZM30.41 38.633c1.659-4.614 2.527-9.605 0-9.125-2.525.48-.705 5.078 1.184 8.166 1.89 3.088 5.477 6.549 7.005 4.538 1.528-2.01-2.493-3.143-7.3-2.851-4.805.291-8.222 3.414-6.653 4.59 1.57 1.175 4.107-.705 5.765-5.318Z", strokeLinecap: "square", stroke: "currentColor" })] })) }))); };
exports.default = SvgFilePdf64;
